module.exports = __webpack_public_path__ + "img/cycling.e904029a.png";